"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegionComponent = void 0;
/**
 * An abstract visial component to define a component of region presentation UI.
 */

var RegionComponent = /*#__PURE__*/function () {
  /**
   * Creates a new UI component (part of the region).
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function RegionComponent(paper, paperRect, regionData) {
    var callbacks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, RegionComponent);

    /**
     * Defines if the component is visible.
     */
    this.isVisible = true;
    /**
     * Defines if the component is in a frozen state.
     */

    this.isFrozen = false;
    /**
     * Defines if the component is selected.
     */

    this.isSelected = false;
    this.paper = paper;
    this.paperRect = paperRect;
    this.regionData = regionData;
    this.callbacks = callbacks;
  }
  /**
   * The `x`-coordinate of the component. Defined through the `regionaData`.
   */


  _createClass(RegionComponent, [{
    key: "hide",

    /**
     * Switches the component presentstion to the hidden state.
     */
    value: function hide() {
      this.node.node.setAttribute("visibility", "hidden");
      this.isVisible = false;
    }
    /**
     * Switches the component presentation to the visibile state.
     */

  }, {
    key: "show",
    value: function show() {
      this.node.node.setAttribute("visibility", "visible");
      this.isVisible = true;
    }
    /**
     * Selects the component.
     */

  }, {
    key: "select",
    value: function select() {
      this.isSelected = true;
      this.node.addClass("selected");
    }
    /**
     * Unselecets the component.
     */

  }, {
    key: "unselect",
    value: function unselect() {
      this.isSelected = false;
      this.node.removeClass("selected");
    }
    /**
     * Switches the component to the frozen state.
     */

  }, {
    key: "freeze",
    value: function freeze() {
      this.isFrozen = true;
    }
    /**
     * Switches the component to the unfrozen state.
     */

  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.isFrozen = false;
    }
  }, {
    key: "move",
    value: function move(arg1, arg2) {
      this.regionData.move(arg1, arg2);
      this.redraw();
    }
    /**
     * Resizes the component to specified `width` and `height`.
     * @param width - The new `width` for the component.
     * @param height - The new `height` for the component.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      this.regionData.resize(width, height);
      this.redraw();
    }
    /**
     * Resizes the bounding box for the component.
     * @param width - The new `width` of the bounding box.
     * @param height - The new `height` of the bounding box.
     */

  }, {
    key: "resizePaper",
    value: function resizePaper(width, height) {
      this.paperRect.resize(width, height);
    }
    /**
     * Subscrubes the component elements according to provided event descriptors. Binds to the `this` object.
     * @param listeners - The collection of event descriptors.
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents(listeners) {
      var _this = this;

      listeners.forEach(function (e) {
        e.base.addEventListener(e.event, _this.makeFreezable(e.listener.bind(_this), e.bypass));
      });
    }
    /**
     * A helper function to make event listeners froozen if the component state is frozen.
     * @param f - Function to wrap.
     * @param bypass - A flag whether event should bypass.
     */

  }, {
    key: "makeFreezable",
    value: function makeFreezable(f) {
      var _this2 = this;

      var bypass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return function (args) {
        if (!_this2.isFrozen || bypass) {
          f(args);
        }
      };
    }
  }, {
    key: "x",
    get: function get() {
      return this.regionData.x;
    }
    /**
     * The `y`-coordinate of the component. Defined through the `regionaData`.
     */

  }, {
    key: "y",
    get: function get() {
      return this.regionData.y;
    }
    /**
     * The `width` of the component. Defined through the `regionaData`.
     */

  }, {
    key: "width",
    get: function get() {
      return this.regionData.boundRect.width;
    }
    /**
     * The `height` of the component. Defined through the `regionaData`.
     */

  }, {
    key: "height",
    get: function get() {
      return this.regionData.boundRect.height;
    }
    /**
     * The `area` of the component. Defined through the `regionaData`.
     */

  }, {
    key: "area",
    get: function get() {
      return this.regionData.area;
    }
    /**
     * The `boundRect` of the component. Defined through the `regionaData`.
     * @remarks Returns the `Rect` object of the same `width` and `height` as the component.
     */

  }, {
    key: "boundRect",
    get: function get() {
      return this.regionData.boundRect;
    }
  }]);

  return RegionComponent;
}();

exports.RegionComponent = RegionComponent;